export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLight-Greek-49fd4d10485a9d29cde09f7fcc04e103.woff";